<template>
  <div>
    <ModalAlert 
      v-if="languageEngine"
      :id="'modal-app-reload'"
      :show="show" 
      :variant="'warning'"
      :title="$t('engine.common.dialogReload.lblTitle', languageEngine)"
      :description="$t('engine.common.dialogReload.lblDescription', languageEngine)"
      :confirm="$t('engine.common.dialogReload.btnReload', languageEngine)"
      :confirmVariant="'primary'"
      :cancel="$t('engine.common.dialogReload.btnCancel', languageEngine)"
      :cancelVariant="'default'"
      :timer="10"
      no-close-on-esc
      no-close-on-backdrop
      @onTimeout="onConfirm"
      @onConfirm="onConfirm"
      @onCancel="onCancel"
      @onClose="onCancel"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ModalAlert from "@components_system/Shared/Tools/ModalAlert/ModalAlert";

export default {
  components: {
    ModalAlert,
  },
  computed: {
    ...mapGetters({
      languageEngine: "design/userPreference/languageEngine",
      reloading: "design/reloading",
    }),
    show() {
      return Boolean(this.reloading.types.renderVersion.reload);
    },
  },
  methods: {
    onConfirm() {
      this.$store.dispatch("design/reload");
    },
    onCancel() {
      this.$store.dispatch("design/stopReload", { type: 'renderVersion' });
    },
  },
};
</script>